import { useContext } from "react";
import { ArrayField, AutocompleteArrayInput, AutocompleteInput, BooleanField, ChipField, CreateButton, Datagrid, FilterButton, List, ReferenceArrayInput, ReferenceInput, sanitizeListRestProps, SearchInput, SingleFieldList, TextField, TopToolbar, useListContext } from "react-admin";
import { AppContext } from "../../providers/app-context-provider/app.context";
import { ProfileEnum } from "../../utils/general-profile.enum";
import ReplicateModelActivities from "./replicate-model-activities";

const SchoolModelActivityList = (props) => {

    const context = useContext(AppContext)
    const superadmin = context.profile.name === ProfileEnum.SUPERADMIN;

    const institutionBranchFilter = (
        <ReferenceInput
            label='Unidade'
            source="institution_branch"
            reference="institution-branches"
            sort={{ field: 'name', order: 'ASC' }}
            perPage={99}
            alwaysOn
            allowEmpty={false}
            resettable
            clearAlwaysVisible={true}
        >
            <AutocompleteInput
                source="name"
                emptyText="Todas"
                optionText={record => context?.profile?.name === ProfileEnum.SUPERADMIN ? `${record?.institution?.name} - ${record?.name}` : record?.name}
            />
        </ReferenceInput>
    )

    const institutionFilter = (
        <ReferenceInput
            label="Instituição"
            source="institution"
            filterToQuery={(text) => ({ "institution.name": text })} reference="institutions"
            sort={{ field: 'institution.name', order: 'ASC' }}
            clearAlwaysVisible={true}
            resettable
            allowEmpty={false}
        >
            <AutocompleteInput
                source="name"
                emptyText="Todas"
                fullWidth
            />
        </ReferenceInput>
    )

    const filters = [
        <SearchInput placeholder="Nome" source="name" alwaysOn />,
        <ReferenceArrayInput
            label="Área"
            source="theme"
            reference="themes"
            sort={{ field: "name", order: "ASC" }}
            alwaysOn
            clearAlwaysVisible={true}
            resettable
        >
            <AutocompleteArrayInput
                source="name"
                emptyText="Todos"
                fullWidth
            />
        </ReferenceArrayInput>
    ];


    if (superadmin || context.profile.name === ProfileEnum.GENERAL_PRINCIPAL) {
        filters.push(institutionBranchFilter)
    }

    if (superadmin) {
        filters.push(institutionFilter)
    }

    const CustomActions = (props) => {
        const {
            className,
            exporter,
            filters,
            maxResults,
            ...rest
        } = props;
        const {
            basePath,
        } = useListContext();
        return (
            <TopToolbar className={className} {...sanitizeListRestProps(rest)}>
                <FilterButton />
                {context.profile.name !== ProfileEnum.GENERAL_PRINCIPAL && <CreateButton basePath={basePath} />}
            </TopToolbar>
        );
    }


    const defaultValues = context?.favoriteThemes?.length > 0 ? { 'theme': context?.favoriteThemes?.map(i => i.id) } : null
    return (
        <List
            title={'Atividades matriz'}
            exporter={false}
            bulkActionButtons={superadmin ? <ReplicateModelActivities /> : false}
            filterDefaultValues={defaultValues}
            sort={{ field: 'name', order: 'ASC' }}
            filters={filters}
            actions={<CustomActions />}
            {...props}
        >
            <Datagrid rowClick={(id, basePath, record) => `/model-activity-dashboard/${id}`} >
                <ArrayField source="themes" label={"Áreas de conhecimento"}><SingleFieldList linkType={false}><ChipField source="name" /></SingleFieldList></ArrayField>
                <TextField source='name' label={'Nome'} />
                <BooleanField source='published' label={'Publicado?'} />
                {context.profile.name === ProfileEnum.SUPERADMIN && <TextField source="institution_branch.institution.name" label={'Instituição'} />}
                {(context.profile.name === ProfileEnum.SUPERADMIN || context.profile.name === ProfileEnum.GENERAL_PRINCIPAL) && <TextField source="institution_branch.name" label={'Unidade'} />}
            </Datagrid>
        </List >
    )
}

export default SchoolModelActivityList